export default {
    type: 'text',
    format: {},
    default: {
        logic: 'contains'
    },
    setting: {
        logic: ['contains']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Wishlist Comment',
        category: ['User', 'Collection'],
        description: 'Comment text on a wishlist item.',
        summarise: {
            prefix: 'Wishlist comment contains'
        }
    },
    rules: {
        linked: [],
        legacy: ['wishlist.comment']
    }
}
